import { Slot } from '@radix-ui/react-slot'
import * as React from 'react'

import { cn } from '../lib/cn'

// Why the rhythm is an enum and not a number — and why `section` is the fourth step —
// is in packages/ui/docs/ritmo-verticale.md.

const GAPS = {
  sm: 'gap-2',
  md: 'gap-3',
  lg: 'gap-4',
  // Named for its job, not its size: it separates whole sections, so it has to be larger
  // than the `lg` that separates a section's own title from its body — or they merge.
  section: 'gap-10',
} as const

/** The steps of the vertical rhythm. Four of them, not an open scale. */
export type StackGap = keyof typeof GAPS

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  /** The step of the vertical rhythm. Defaults to `md`. */
  gap?: StackGap
  /** Renders the child instead of a `div`: to lay out a `section`, `ul` or `form`. */
  asChild?: boolean
}

/** A column whose vertical rhythm comes from the design system. */
export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ className, gap = 'md', asChild = false, ...props }, ref) => {
    const Component = asChild ? Slot : 'div'
    return <Component ref={ref} className={cn('flex flex-col', GAPS[gap], className)} {...props} />
  },
)
Stack.displayName = 'Stack'
